<template>
  <div class="child-page-div">
    <div class="page-content-div">
      <table-box ref="tableBox" :tableTitle="'版本管理'" :tableFieldNum="tableFieldNum" :action="action" :params="queryParams" :reloadData.sync="reloadData">
        <template #title-right>
          <div class="search-div">
            <label>
              <select v-model="searchType">
                <option value="1">版本名称</option>
              </select>
            </label>
            <label>
              <input class="search-input" type="text" maxlength="20" v-model="searchMsg" placeholder="搜索相关数据..." />
            </label>
            <input class="search-btn" type="button" value="搜索" @click="onSearch" />
          </div>
        </template>
        <template #table-head>
          <th v-for="(item, index) in tableField" v-show="item.state" :key="index">{{ item.alias }}</th>
          <th v-if="isOperation" class="operation-th">操作</th>
        </template>
        <template v-if="$hasAuthority(9900000,9901000,[9901001])" #tableSubHead>
          <th class="table-sub-head-th" :colspan="tableFieldNum">
            <div class="div-btn cursor-el append-btn" @click="onShowAddVersion">
              <img src="../../assets/add-data.png" height="14" width="14" alt="" />
              <label class="cursor-el">添加版本</label>
            </div>
          </th>
        </template>
        <template #table-body="props">
          <tr>
            <template v-for="(item, index) in tableField">
              <td v-if="item.isHtml" :key="index" v-show="item.state" v-html="item.value(props.item, item.name)" />
              <td v-else :key="index" v-show="item.state">{{ item.value(props.item, item.name) }}</td>
            </template>
            <td v-if="isOperation">
              <div class="operation-btn-div">
                <span v-if="$validateAuthority(9900000,9901000,9901003)" class="cursor-el" @click="onEditItem(props.item.id)">编辑</span>
                <span v-if="$validateAuthority(9900000,9901000,9901002)" class="cursor-el" @click="onDelItem(props.item)">删除</span>
              </div>
            </td>
          </tr>
        </template>
      </table-box>
    </div>
  </div>
</template>

<script>
import TableBox from "../../components/TableBox";
import VersionAddLayer from "../layer/VersionAddLayer";
import VersionEditLayer from "../layer/VersionEditLayer";
import { getVersionItems, postVersionDel } from "../../common/api";

export default {
  name: "AppVersions",
  components: { TableBox },
  data() {
    return {
      action: getVersionItems,
      reloadData: false,
      searchType: "1",
      searchMsg: "",
      queryParams: {
        type: 0,
        msg: "",
        pageSize: 20
      },
      tableField: [
        { state: true, alias: "编号", name: "id", title: "id", isHtml: false, value: this.getObjValue },
        { state: true, alias: "类型", name: "type", title: "type", isHtml: false, value: this.getObjValue },
        { state: true, alias: "版本号", name: "versionCode", title: "versionCode", isHtml: false, value: this.getObjValue },
        { state: true, alias: "版本名称", name: "versionName", title: "versionName", isHtml: false, value: this.getObjValue },
        { state: true, alias: "文件大小", name: "fileSize", title: "fileSize", isHtml: false, value: this.getObjValue },
        { state: true, alias: "文件MD5", name: "fileMd5", title: "fileMd5", isHtml: false, value: this.getObjValue },
        { state: true, alias: "更新说明", name: "content", title: "content", isHtml: false, value: this.getObjValue },
        { state: true, alias: "更新方式", name: "state", title: "state", isHtml: false, value: this.getObjValue },
        { state: true, alias: "上传人", name: "creator", title: "creator", isHtml: false, value: this.getObjValue },
        { state: true, alias: "上传时间", name: "createTime", title: "createTime", isHtml: false, value: this.getObjValue }
      ]
    };
  },
  computed: {
    isOperation() {
      return this.$hasAuthority(9900000,9901000,[9901002, 9901003]);
    },
    tableFieldNum() {
      let num = 0;
      this.tableField.forEach(function(value) {
        if (value.state) {
          ++num;
        }
      });
      return num;
    }
  },
  methods: {
    getObjValue(item, field) {
      if(field === "type"){
        return this.getAppType(item[field]);
      }else if(field === "fileSize"){
        return `${Math.ceil(item[field] / 1024 / 1024)}MB`;
      }else if(field === "state"){
        return item[field] === 1 ? "强制更新" : "选择更新";
      }else{
        return item[field];
      }
    },
    getAppType(type) {
      switch (type) {
        case 1: return "用户端";
        case 2: return "商家端";
        case 3: return "服务端";
        default: return "";
      }
    },
    onReloadData() {
      this.reloadData = true;
    },
    onSearch() {
      this.queryParams.type = this.searchType;
      this.queryParams.msg = this.searchMsg.trim();
    },
    onShowAddVersion() {
      this.$layer.iframe({
        content: {
          content: VersionAddLayer,
          parent: this,
          data: {
            refreshData: this.onReloadData
          }
        },
        area: ["600px", "510px"],
        title: "上传更新包"
      });
    },
    onDelItem(item) {
      this.$layer.confirm(`是否删除版本【${this.getAppType(item.type)} - ${item.versionName}】？`, layerid => {
        postVersionDel({ id: item.id })
          .then(() => {
            this.$layer.msg("操作成功");
            this.onReloadData();
            this.$layer.close(layerid);
          })
          .catch(error => {
            this.$layer.close(layerid);
            if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
              this.$layer.msg(error.data.msg);
            } else {
              this.$layer.msg("操作失败");
            }
          });
      });
    },
    onEditItem(versionId) {
      this.$layer.iframe({
        content: {
          content: VersionEditLayer,
          parent: this,
          data: {
            versionId: versionId,
            refreshData: this.onReloadData
          }
        },
        area: ["600px", "510px"],
        title: "编辑版本信息"
      });
    }
  }
}
</script>

<style lang="less" scoped>
.child-page-div {
  width: 100%;
  .page-content-div {
    border-radius: 5px;
    background-color: #ffffff;
    padding: 30px 20px 10px 20px;
    .search-div {
      height: 100%;
      display: flex;
      select {
        width: 110px;
        height: 100%;
        border: 1px solid #dcdcdc;
      }
      .search-input {
        width: 140px;
        height: 33px;
        border: 1px solid #dcdcdc;
        padding: 0 15px;
        margin-left: 5px;
      }
      .search-btn {
        width: 80px;
        height: 100%;
        color: #f4f6f5;
        border: none;
        background: #4676c8;
      }
    }
    .table-sub-head-th {
      .div-btn {
        float: left;
        width: 88px;
        height: 23px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          margin-right: 10px;
        }
      }
      .append-btn {
        margin-left: 15px;
        margin-right: 10px;
      }
    }
    .operation-btn-div {
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>